import { CHANGE_ENTITY } from "./types"


export const changeEntity = (entity) => {
    return {
        type : CHANGE_ENTITY,
        payload: entity
    }
}